<!-- Welcome Section -->
<ng-container *ngIf="!showForm && !isSubmitted">
    <h1 class="text-gray-700 mb-10 mt-[150px] text-center font-bold text-4xl">
        Paris American International University
    </h1>
    <div class="md:w-[40%] py-4 rounded mx-auto flex flex-wrap justify-center overflow-y-scroll h-[620px] border">
        <img src="assets/image/download.png" alt="" class="border" />
        <img src="assets/image/download.png" alt="" class="mt-3 border" />
    </div>
    <div class="md:w-[40%] mx-auto py-4">
        <button
            class="w-full rounded py-3 text-white btn bg-blue-500 hover:bg-blue-600 duration-300"
            (click)="toggleForm()"
        >
            Start Filling
        </button>
    </div>
</ng-container>

<ng-container *ngIf="showForm && !isSubmitted">
    <img src="assets/image/header-img/paiu-logo.jpg" alt="" class="mt-[150px] mx-auto w-[25%]" />
    <div class="max-w-4xl border mx-auto bg-white shadow-lg rounded-lg">
        <div class="border-b-2 p-3 text-center">
            <h2 class="text-4xl text-gray-700 font-bold">
                Paris American International University
            </h2>
            <small class="text-center text-gray-700">Student Application Form</small>
        </div>

        <form [formGroup]="applicationForm" (ngSubmit)="onSubmit()" class="space-y-4 px-5 py-6">
                <div>
                    <label for="name" class="block text-sm font-medium">Name</label>
                    <input
                        id="name"
                        type="text"
                        formControlName="name"
                        class="mt-1 w-full border rounded-lg px-3 py-2"
                    />
                    <div *ngIf="applicationForm.get('name')?.invalid && applicationForm.get('name')?.touched" class="text-red-500 text-sm">
                        Name is required.
                    </div>
                </div>

                <!-- Email -->
                <div>
                    <label for="email" class="block text-sm font-medium">Email</label>
                    <input
                        id="email"
                        type="email"
                        formControlName="email"
                        class="mt-1 w-full border rounded-lg px-3 py-2"
                    />
                    <div *ngIf="applicationForm.get('email')?.invalid && applicationForm.get('email')?.touched" class="text-red-500 text-sm">
                        Please enter a valid email address.
                    </div>
                </div>

                <!-- Phone Number -->
                <div>
                    <label for="phone" class="block text-sm font-medium">Phone Number</label>
                    <input
                        id="phone"
                        type="tel"
                        formControlName="phone"
                        class="mt-1 w-full border rounded-lg px-3 py-2"
                    />
                    <div *ngIf="applicationForm.get('phone')?.invalid && applicationForm.get('phone')?.touched" class="text-red-500 text-sm">
                        Phone number is required.
                    </div>
                </div>

                <!-- Gender -->
                <div>
                    <label class="block text-sm font-medium">Gender</label>
                    <div class="mt-1 flex space-x-4">
                        <label class="flex items-center space-x-2">
                            <input
                                type="radio"
                                formControlName="gender"
                                value="Male"
                                class="form-radio"
                            />
                            <span>Male</span>
                        </label>
                        <label class="flex items-center space-x-2">
                            <input
                                type="radio"
                                formControlName="gender"
                                value="Female"
                                class="form-radio"
                            />
                            <span>Female</span>
                        </label>
                    </div>
                    <div *ngIf="applicationForm.get('gender')?.invalid && applicationForm.get('gender')?.touched" class="text-red-500 text-sm">
                        Please select your gender.
                    </div>
                </div>

                <!-- Address -->
                <div>
                    <label for="address" class="block text-sm font-medium">Address</label>
                    <input
                        id="address"
                        type="tel"
                        formControlName="address"
                        class="mt-1 w-full border rounded-lg px-3 py-2"
                    />
                    <div *ngIf="applicationForm.get('address')?.invalid && applicationForm.get('address')?.touched" class="text-red-500 text-sm">
                        Address is required.
                    </div>
                </div>
            <div>
                <label for="postalCode" class="block text-sm font-medium">Postal Code</label>
                <input
                    id="postalCode"
                    type="tel"
                    formControlName="postalCode"
                    class="mt-1 w-full border rounded-lg px-3 py-2"
                />
                <div *ngIf="applicationForm.get('postalCode')?.invalid && applicationForm.get('postalCode')?.touched" class="text-red-500 text-sm">
                    Postal is required.
                </div>
            </div>
            <div>
                <label for="postalCode" class="block text-sm font-medium">City</label>
                <input
                        id="city"
                        type="text"
                        formControlName="city"
                        class="mt-1 w-full border rounded-lg px-3 py-2"
                    />
                <div *ngIf="applicationForm.get('city')?.invalid && applicationForm.get('city')?.touched" class="text-red-500 text-sm">
                    City is required.
                </div>
            </div>
            <div>
                <label for="state" class="block text-sm font-medium">State</label>
                <input
                        id="state"
                        type="text"
                        formControlName="state"
                        class="mt-1 w-full border rounded-lg px-3 py-2"
                    />
                <div *ngIf="applicationForm.get('state')?.invalid && applicationForm.get('state')?.touched" class="text-red-500 text-sm">
                    State is required.
                </div>
            </div>
            <div>
                <label for="institution" class="block text-sm font-medium">Institution</label>
                <input
                        id="institution"
                        type="tel"
                        formControlName="institution"
                        class="mt-1 w-full border rounded-lg px-3 py-2"
                    />
                <div *ngIf="applicationForm.get('institution')?.invalid && applicationForm.get('institution')?.touched" class="text-red-500 text-sm">
                    Institution is required.
                </div>
            </div>
            <div>
                <label for="graduationYear" class="block text-sm font-medium">Graduation Year</label>
                <input
                        id="graduationYear"
                        type="date"
                        formControlName="graduationYear"
                        class="mt-1 w-full border rounded-lg px-3 py-2"
                    />
                <div *ngIf="applicationForm.get('graduationYear')?.invalid && applicationForm.get('graduationYear')?.touched" class="text-red-500 text-sm">
                    Graduation year is required.
                </div>
            </div>
            <div>
                <label for="postalCode" class="block text-sm font-medium">Major</label>
                <input
                        id="major"
                        type="text"
                        formControlName="major"
                        class="mt-1 w-full border rounded-lg px-3 py-2"
                    />
                <div *ngIf="applicationForm.get('major')?.invalid && applicationForm.get('major')?.touched" class="text-red-500 text-sm">
                    Major is required.
                </div>
            </div>
            <div>
                <label for="company" class="block text-sm font-medium">Company</label>
                <input
                        id="company"
                        type="tel"
                        formControlName="company"
                        class="mt-1 w-full border rounded-lg px-3 py-2"
                    />
            </div>
            <div>
                <label for="experience" class="block text-sm font-medium">Experience</label>
                <input
                        id="experience"
                        type="text"
                        formControlName="experience"
                        class="mt-1 w-full border rounded-lg px-3 py-2"
                    />
            </div>
            <div>
                <label for="position" class="block text-sm font-medium">Position</label>
                <input
                    id="position"
                    type="text"
                    formControlName="position"
                    class="mt-1 w-full border rounded-lg px-3 py-2"
                />
            </div>
            <div>
                <label for="program" class="block text-sm font-medium">Select Program</label>
                <select
                    id="program"
                    formControlName="selectedProgram"
                    class="mt-1 w-full border rounded-lg px-3 py-2"
                >
                    <option value="" disabled>Select a program</option>
                    <option class="flex w-full justify-between" *ngFor="let program of programs; let i = index" [value]="program.name">
                                {{i +1}}.
                                 {{ program.name }}

                    </option>
                </select>
            </div>

            <!-- Passport Upload -->
            <div>
                <label class="block text-sm font-medium">Passport Upload</label>
                <input type="file" formControlName="passportUpload" class="mt-1" />
            </div>

            <!-- ID Upload -->
            <div>
                <label class="block text-sm font-medium">ID Upload</label>
                <input type="file" formControlName="idUpload" class="mt-1" />
            </div>

            <!-- Disclaimer -->
            <div>
                <label class="block text-sm font-medium">Disclaimer</label>
                <textarea
                    formControlName="disclaimer"
                    class="mt-1 w-full border rounded-lg px-3 py-2"
                ></textarea>
            </div>

            <!-- Signature -->
            <div>
                <label for="signature" class="block text-sm font-medium">Signature</label>
                <input
                    id="signature"
                    type="text"
                    formControlName="signature"
                    class="mt-1 w-full border rounded-lg px-3 py-2"
                />
            </div>

            <div class="text-center">
                <button
                    type="submit"
                    class="rounded px-4 py-2 bg-green-500 text-white hover:bg-green-600"
                >
                    Submit
                </button>
            </div>
        </form>
    </div>
</ng-container>

<!-- Success Message -->
<ng-container *ngIf="isSubmitted">
    <div class="text-center mt-[150px]">
        <h2 class="text-4xl font-bold text-green-600">Thank You!</h2>
        <p class="mt-4 text-gray-700">Your application has been submitted successfully.</p>
        <button
            class="mt-6 px-6 py-3 bg-blue-500 text-white rounded hover:bg-blue-600"
            (click)="resetForm()"
        >
            Submit Another Application
        </button>
    </div>
</ng-container>
